import { HttpClient } from '@angular/common/http';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UserWidgetVm } from 'app/shared/generated/Administration/Models/Users/UserWidgetVm';
import { GlobalService } from 'app/shared/services/global.service';
import { SharedTableModule } from 'app/shared/standalone/shared-table/shared-table.module';
import { AvailableColumns, VisibleColsService } from 'app/shared/standalone/shared-table/visible-cols.service';

@Component({
  selector: 'pcg-admin-widget-list',
  imports: [SharedTableModule],
  templateUrl: './admin-widget-list.component.html',
  styleUrl: './admin-widget-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { '(window:resize)': 'onResize()' },
})
export class AdminWidgetListComponent {

    http = inject(HttpClient);
    router = inject(Router);

    columnDefs = UserWidgetVm.ColumnDefs;
    availableColumns!: AvailableColumns[];
    visibleColumns!: AvailableColumns[];
    searchColumns!: string[];
    list: UserWidgetVm[] = [];
    isLoading: boolean = true;
    isMobile = false;
    tableDts = { root: { header: { lgPadding: "0 0 0.5rem 0" } } };

    onResize() { this.isMobile = GlobalService.setIsMobile(window.innerWidth); }

    ngOnInit() {
        this.isMobile = GlobalService.setIsMobile(window.innerWidth); 
        this.availableColumns = VisibleColsService.getAvailableCols(this.columnDefs);
        this.visibleColumns = this.availableColumns.filter(o => o.isVisible);
        this.searchColumns = this.availableColumns.filter(o => o.canSearch).map(o => o.field);
        this.getList();
    }

    getList() {
        this.http.get<UserWidgetVm[]>('api/Admin/Widgets/GetAdminList').subscribe((list: UserWidgetVm[]) => {
            this.list = list;
            this.isLoading = false;
        })
    }

    redirectToEdit(row: any) { this.router.navigateByUrl(`admin/system/widgets/edit/${row.widgetId}`); }

    columnChange(event: any) {
        this.visibleColumns = event;
        this.visibleColumns = event.sort((a, b) => {
            return this.availableColumns.findIndex(p => p.field === a.field) 
                - this.availableColumns.findIndex(p => p.field === b.field);
        });
    }
}
